import React from 'react';

const WrapText: React.FunctionComponent<{ text: string }> = ({ text }) => {
    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>{text}</div>;
};

export default WrapText;
